const TENANT_ID = 5512
const STATIC_URL = 'https://static.sizebay.technology/'
const MODULE_URL = 'https://vfr-v3-production.sizebay.technology/V4/implantation/index.js'
const PRODUCT_LANG = document.querySelector('html').lang || 'he'
const preview = true

const TEXT_LANG = {
  en: {
    recommendation: {
      default: 'We recommend size {size} for {profileName}',
      simplified: 'We recommend size {size}',
    },
    buttons: {
      vfr: 'Virtual Fitting Room',
      chart: 'Size guide',
      helper: 'Need some help?',
    },
  },
  he: {
    recommendation: {
      default: 'אנו ממליצים על מידה {size} עבור {profileName}',
      simplified: preview ? '✓ ההמלצה שלנו: {size}' : 'ההמלצה שלנו: {size}',
    },
    buttons: {
      vfr: 'שאלון התאמה',
      chart: preview ? 'טבלת מידות' : '',
      helper: preview ? 'מתלבטת?' : 'מה המידה שלי?',
    },
  },
}

window.SizebayPrescript = () => ({
  getPermalink() {
    return ''
  },
  getTenantId() {
    return TENANT_ID
  },
  getLanguage() {
    return PRODUCT_LANG
  },
  getButtons() {
    return {
      order: [
        {
          name: 'vfr',
          text: TEXT_LANG[PRODUCT_LANG].buttons.vfr,
        },
        preview ? { name: 'measurements', text: TEXT_LANG[PRODUCT_LANG].buttons.chart } : '',
      ],
      position: 'append',
      class: 'vfr__button--clean',
    }
  },
  getRecommendationText() {
    return {
      default: TEXT_LANG[PRODUCT_LANG].recommendation.default,
      simplified: TEXT_LANG[PRODUCT_LANG].recommendation.simplified,
      order: preview ? 'before' : 'prepend',
      anchor: preview ? '#szb-measurements-button' : '.vfr__container',
    }
  },
  getConfigProfile() {
    if (preview) {
      return 'calculatingTrue'
    }
  },
})

function prefix(index) {
  if (preview) {
    const container = document.getElementById(`szb-look-${index}`)
    if (!container) return

    const vfr = container.querySelector('#szb-vfr-button')
    if (!vfr) return

    const isVfrButton = vfr.textContent?.trim() === TEXT_LANG[PRODUCT_LANG].buttons.vfr
    if (!isVfrButton) return

    if (vfr.previousElementSibling?.classList?.contains('szb__helper')) return

    const div = document.createElement('div')
    div.setAttribute('class', 'szb__helper')
    div.innerHTML = `<span class="szb__text-container"><span class="szb__span--text">${TEXT_LANG[PRODUCT_LANG].buttons.helper}</span><span class="szb__vfr-button">${TEXT_LANG[PRODUCT_LANG].buttons.vfr}</span></span>`

    vfr.before(div)
  }
}

function insertElement(tag, attrs, parent) {
  const element = document.createElement(tag)
  Object.entries(attrs).forEach(([key, value]) => element.setAttribute(key, value))
  parent.appendChild(element)
}

function insertStyle(ref) {
  insertElement('link', { rel: 'stylesheet', type: 'text/css', href: ref }, document.querySelector('body'))
}

function insertScript(ref) {
  insertElement('script', { src: ref, id: 'szb-vfr__base' }, document.querySelector('head'))
}

function init() {
  insertScript('https://vfr-v3-production.sizebay.technology/V4/implantation/index.js')
  customStyle()
}

function customStyle() {
  preview
    ? insertStyle('https://static.sizebay.technology/5512/styles/styles_preview.css')
    : insertStyle('https://static.sizebay.technology/5512/styles/styles_v4.css')
}

function selectProduct(index) {
  let productElements
  if (document.querySelectorAll('div.gbbProductItem').length > 0) {
    productElements = document.querySelectorAll('div.gbbProductItem')
  } else {
    productElements = document.querySelectorAll('div.product-card')
  }

  let productUrls
  if (document.querySelectorAll('div.gbbProductItem').length > 0) {
    productUrls = Array.from(productElements).map((element) => {
      return element.getAttribute('productid')
    })
  } else {
    productUrls = Array.from(productElements).map((element) => {
      return element.dataset.productId
    })
  }

  const baseUrl = 'https://lilibloom.co.il/products/'

  if (productElements.length > 0 && productUrls[index]) {
    return baseUrl + productUrls[index]
  } else {
    return baseUrl + (ShopifyAnalytics?.meta?.product?.id || '')
  }
}

function sizebayObserver() {
  if (window.szbObserverActive) return
  window.szbObserverActive = true

  const runCheck = () => {
    const gbbItems = document.querySelectorAll('.gbbProductItem')
    const safeSticky = document.querySelector('safe-sticky.product-info')

    if (gbbItems.length > 0) {
      gbbItems.forEach((product, index) => {
        const lookId = `szb-look-${index}`
        let vfrBox = document.getElementById(lookId)
        const dropdownWrapper = product.querySelector('.gbbVariantDropdownWrapper')

        if (dropdownWrapper) {
          if (!vfrBox) {
            vfrBox = document.createElement('div')
            vfrBox.setAttribute('id', lookId)
            dropdownWrapper.after(vfrBox)
            reInjectSizebay(index, lookId)
          } else if (dropdownWrapper.nextElementSibling !== vfrBox) {
            dropdownWrapper.after(vfrBox)
          }
        }
      })
    } else if (safeSticky) {
      const lookId = 'szb-look-0'
      let vfrBox = document.getElementById(lookId)

      const anchor = preview
        ? safeSticky.querySelector('.variant-picker__option:nth-child(2) .variant-picker__option-info .h-stack')
        : safeSticky.querySelector('.variant-picker__option .variant-picker__option-info')

      if (anchor) {
        if (!vfrBox) {
          vfrBox = document.createElement('div')
          vfrBox.setAttribute('id', lookId)
          anchor.append(vfrBox)
          reInjectSizebay(0, lookId)
        } else if (!anchor.contains(vfrBox)) {
          anchor.append(vfrBox)
        }
      }
    }
  }

  const reInjectSizebay = (index, id) => {
    window?.Sizebay?.Implantation({
      permalink: selectProduct(index),
      tenantId: TENANT_ID,
      buttons: window.SizebayPrescript().getButtons(),
      anchor: { mobile: `#${id}`, web: `#${id}` },
      lang: PRODUCT_LANG,
      recommendation: window.SizebayPrescript().getRecommendationText(),
    })
  }

  runCheck()
  const observer = new MutationObserver(runCheck)
  observer.observe(document.body, { subtree: true, childList: true })
}

function SizebayInit() {
  init()
  const { SizebayPrescript } = window
  const tenantId = SizebayPrescript().getTenantId()
  const buttons = SizebayPrescript().getButtons()
  const lang = SizebayPrescript().getLanguage()
  const recommendation = SizebayPrescript().getRecommendationText()

  const isCardView = document.querySelectorAll('div.product-card').length > 0
  const isKits = document.querySelectorAll('.gfbFrequentBoughtWidgetProductContainer').length > 1
  const isLook = document.querySelectorAll('div.gbbProductsItemsContainer').length > 0
  let items

  if (isKits) {
    items = document.querySelectorAll('div[data-block-id="separator"]')
  } else if (isCardView) {
    items = document.querySelectorAll('div.product-card div.product-card-cta')
  } else if (isLook) {
    items = document.querySelectorAll('div.gbbVariantDropdownWrapper')
  } else {
    items = preview
      ? document.querySelectorAll(
          '.product-info__variant-picker .variant-picker__option:nth-child(2) .variant-picker__option-info .h-stack'
        )
      : document.querySelectorAll(
          '.product-info__variant-picker .variant-picker__option:nth-child(2) .variant-picker__option-info'
        )
  }

  items.forEach((item, index) => {
    const divLook = document.createElement('div')
    divLook.setAttribute('id', `szb-look-${index}`)

    if (isCardView) {
      item.prepend(divLook)
    } else if (isLook) {
      item.after(divLook)
    } else {
      item.append(divLook)
    }

    const permalink = selectProduct(index)
    console.log('Sizebay Product Link Updated ' + index + ':', permalink)
    const anchor = { mobile: `#szb-look-${index}`, web: `#szb-look-${index}` }
    const payload = { permalink, tenantId, buttons, anchor, lang, recommendation }

    const sizebayRender = () => {
      window?.Sizebay?.Implantation(payload)
    }

    window.addEventListener('sizebay:loaded', () => {
      sizebayRender()
    })

    window.addEventListener('sizebay:rendered', () => {
      if (!isCardView) {
        sizebayObserver()
      }
      if (preview) {
        document.addEventListener('click', (e) => {
          const rec = e.target.closest('#szb-vfr-recommendation')
          if (!rec) return

          const container = rec.closest('.vfr__container')
          const vfr = container?.querySelector('#szb-vfr-button')

          if (vfr) {
            vfr.click()
          }
        })
        prefix(index)
      }
    })
  })
}

const waitFor = (s, cb) => {
  const o = new MutationObserver(() => {
    if (document.querySelector(s)) o.disconnect(), cb()
  })
  o.observe(document.body, { childList: true, subtree: true })
}

if (location.href.includes('/products/')) {
  ;[
    'div.product-card div.product-card-cta',
    '.variant-picker__option:has(.block-swatch)',
    '.gfbFrequentBoughtVariantUIParentContainer',
    'div.gbbProductsItemsContainer',
  ].forEach((s) => waitFor(s, SizebayInit))
}
